/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-22 16:14:04
 * @Explain: 模板管理(邮件，短信)
 */

export default {
  // 列表
  'TEMPLATE.MANAGE.LIST.TITLE': 'Templates list',
  'TEMPLATE.MANAGE.NO.TEMPLATE': 'No templates',
  'TEMPLATE.MANAGE.ADD.TEMPLATE': 'Create marketing template',
  'TEMPLATE.MANAGE.ADD.MISSING.VARIABLE': 'Contains non-existent keys',
  'TEMPLATE.MANAGE.ADD.MISSING.VARIABLE.DES':
    'Contains non-existent keys/attributes',
  'TEMPLATE.MANAGE.UN.ACTIVE.FORM': 'Contains inactive forms',
  'TEMPLATE.MANAGE.ADD.MISSING.UNSUBSCRIBED': 'Unsubscribe link is missing',
  'TEMPLATE.MANAGE.ADD.TRANS.TEMPLATE': 'Create transactional template',
  'TEMPLATE.MANAGE.CREATE.FIRST.TEMPLATE': 'Create my first template',
  'TEMPLATE.MANAGE.TEMPLATE.LANGUAGE': 'Template language',
  'TEMPLATE.MANAGE.TEMPLATE.NAME': 'Template name',
  'TEMPLATE.MANAGE.MARKET.TEMPLATE.PREVIEW': 'Preview',
  'TEMPLATE.MANAGE.TEMPLATE.SUBSCRIBE.STATUS':
    'Unsubscribe & subscriber preferences',
  'TEMPLATE.MANAGE.PLEASE.SELECT.SUBSCRIBESTATUS': 'Please select',
  'TEMPLATE.MANAGE.TEMPLATE.SUBSCRIBETIP1': 'Go to',
  'TEMPLATE.MANAGE.TEMPLATE.SUBSCRIBETIP2': "'update preferences'",
  'TEMPLATE.MANAGE.PLEASE.SELECT.TEMPLATE.LANGUAGE.LABEL': 'Language',
  'TEMPLATE.MANAGE.PLEASE.SELECT.TEMPLATE.LANGUAGE.LABEL.DES':
    'Template language',
  'TEMPLATE.MANAGE.PLEASE.SELECT.TEMPLATE.LANGUAGE.LABEL.DES.PHD':
    'Select language',
  'TEMPLATE.MANAGE.PLEASE.SELECT.TEMPLATE.LANGUAGE': 'Select template language',
  'TEMPLATE.MANAGE.EDITOR': 'Edited by',
  'TEMPLATE.MANAGE.PLACEHOLDER': 'keys/Contact attributes',
  'TEMPLATE.MANAGE.MARKET.UNSUBSCRIBE': 'Unsubscribe link',
  'TEMPLATE.MANAGE.LAST.SAVED': 'Last edited',
  'TEMPLATE.MANAGE.VIEW.PLACEHOLDERS': 'View Keys',
  'TEMPLATE.MANAGE.EXPORT.HTML.FILE': 'Export as HTML',
  'TEMPLATE.MANAGE.DIALOG.EXPORT.HTML.FILE.TITLE':
    'Select the template language to export',
  'TEMPLATE.MANAGE.DIALOG.EXPORT.HTML.FILE.CONFIRM': 'Confirm export',

  'TEMPLATE.MANAGE.IS.DEL.TEMP': 'Delete marketing email template?',
  'TEMPLATE.MANAGE.IS.DEL.TRANS.TEMP': 'Delete transactional email',
  'TEMPLATE.MANAGE.DELETE.DES':
    '<span class="delete-dialog-mark">{name}</span> will be permanently deleted and cannot be restored.',
  'TEMPLATE.MANAGE.DELETE.TRANS.DES':
    '<span class="delete-dialog-mark">{name}</span> will be permanently deleted and cannot be restored,Interfaces that use this template will receive a return error',
  'TEMPLATE.MANAGE.DELETE.CONFIRM': 'Type <b>DELETE</b> to confirm',
  'TEMPLATE.MANAGE.DELETE.CONFIRM.ERROR': 'Input DELETE to confirm',
  'TEMPLATE.MANAGE.DELETE.CONFIRM.INPUT': 'DELETE',

  'TEMPLATE.MANAGE.IS.ROLLBACK.TEMP': 'Revoke publication',
  'TEMPLATE.MANAGE.IS.ROLLBACK.TEMP.SUCCESS': 'Successfully revoke publication',
  'TEMPLATE.MANAGE.ROLLBACK.DES':
    "After revoking, the previously published template will be activated and the revoked template will change to a 'Draft' status.",
  'TEMPLATE.MANAGE.TIP.INPUT.PHD': 'Enter here',
  'TEMPLATE.MANAGE.ROLLBACK.TRANS.DES': '',
  'TEMPLATE.MANAGE.ROLLBACK.CONFIRM': 'Type <b>WITHDRAW</b> to confirm',
  'TEMPLATE.MANAGE.ROLLBACK.CONFIRM.ERROR': 'Input WITHDRAW to confirm',
  'TEMPLATE.MANAGE.ROLLBACK.CONFIRM.INPUT': 'WITHDRAW',

  'TEMPLATE.MANAGE.ADD.HTML.TEMPLATE.MARKET': 'Create marketing email template',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.MARKET': 'Create marketing email template',
  'TEMPLATE.MANAGE.PLEASE.ENTER.A.TEMPLATE.NAME':
    'Enter your template name, character limit is 50',
  'TEMPLATE.MANAGE.NEW.TEMPLATE.METHOD': 'New template creation method',
  'TEMPLATE.MANAGE.UPLOAD.HTML.FILE': 'Upload HTML file',
  'TEMPLATE.MANAGE.RICH.TEXT': 'Rich text editor',
  'TEMPLATE.MANAGE.PLEASE.UPLOAD.HTML.FILE': 'Upload HTML file',
  'TEMPLATE.MANAGE.PASTE.HTML.CODE': 'Paste HTML code',
  'TEMPLATE.MANAGE.MULTI.MEDIA.EDITOR': 'Design by layouts',
  'TEMPLATE.MANAGE.TEMPLATE.PREVIEW': 'Template preview',
  'TEMPLATE.MANAGE.EDIT.CODE': 'Edit code',
  'TEMPLATE.MANAGE.EDIT.CODE.TIPS':
    'Tip: use {paramName} to represent variables in the template. Names for variables can only support alphanumerical characters and underscores, and are case-sensitive.',
  'TEMPLATE.MANAGE.CONTENT.ERROR':
    'The content is incorrect. Please contact tech support to check the problem.',
  'TEMPLATE.MANAGE.PLEASE.FILL.IN.THE.CODE.CONTENT': 'Fill in the content',
  'TEMPLATE.MANAGE.FOLDER': 'Folder',
  'TEMPLATE.MANAGE.NAME': 'Search template',
  'TEMPLATE.MANAGE.DELETE.FOLDER0':
    'Are you sure you want to delete this folder?',
  'TEMPLATE.MANAGE.DELETE.FOLDER1':
    'Once the folder has been deleted, it cannot be retrieved anymore. Do you want to proceed?',
  'TEMPLATE.MANAGE.MOVETO': 'Move to',
  'TEMPLATE.MANAGE.ADD.FOLDER': 'Create new folder',
  'TEMPLATE.MANAGE.MOVE': 'Move template',
  'TEMPLATE.MANAGE.SELECT': 'Select folder',
  'TEMPLATE.CANCEL.SUBSCRIPTION': 'You can unsubscribe',
  'TEMPLATE.CANCEL.SUBSCRIPTION.DES':
    'An unsubscribe link is added automatically in the footer of the email. Once the player clicks this link, their subscription status will be updated immediately in "Contacts". Subsequently, unsubscribed players will be automatically excluded from receiving future emails sent from SmartLink.',
  'TEMPLATE.MANAGE.MOVE.SUCCESS': 'Moved successfully',
  'TEMPLATE.MANAGE.UNSUBSCRIBE': 'Unsubscribe from this email',
  'TEMPLATE.MANAGE.ENTER.NAME': 'Enter a folder name',
  'TEMPLATE.MANAGE.CHECK.NAME': 'Folder name cannot be empty',
  'TEMPLATE.MANAGE.EDITING': 'Currently being edited',
  'TEMPLATE.MANAGE.LINK.EXIST': 'Added',
  'TEMPLATE.MANAGE.LINK.NOT.EXIST': 'Missing',
  'TEMPLATE.MANAGE.PND.INCLUDE.NOT.ADD': 'Contains non-existent keys',
  'TEMPLATE.MANAGE.ACTIVITY': 'Being used in ongoing campaign',
  'TEMPLATE.MANAGE.EDITING.NAME': '{name} is editing...',
  'TEMPLATE.MANAGE.EDITING.TIPS': '*Only 1 person can be editing at a time',
  'TEMPLATE.MANAGE.OTHERS.EDITING.TIPS': 'Someone else is currently editing',
  'TEMPLATE.MANAGE.SEND.CONTENT.ERROR': 'Failed to retrieve email content',
  'TEMPLATE.MANAGE.SEND.ERROR': 'Failed to send',
  'TEMPLATE.MANAGE.MULTILINGUAL.EDIT': 'Edit multilingual text',
  'TEMPLATE.MANAGE.MULTILINGUAL.SYNC': 'Synchronization',
  'TEMPLATE.MANAGE.MULTILINGUAL.INIT.LANGUAGE': 'Original language',
  'TEMPLATE.MANAGE.VERIFY.VAR.TITLE': 'Keys',
  'TEMPLATE.MANAGE.VERIFY.CONTACT.TITLE': 'Personal information',
  'TEMPLATE.MANAGE.VERIFY.CONTACT.NAME': 'Contact attributes',
  'TEMPLATE.MANAGE.VERIFY.VAR.NAME': 'Keys',
  'TEMPLATE.MANAGE.VERIFY.VAR.TYPE': 'Type',
  'TEMPLATE.MANAGE.VERIFY.VAR.ASSIGNMENT.SITUATION': 'Number of Available Keys',
  'TEMPLATE.MANAGE.CONTACT.COLUMN': 'Default value setting',
  'TEMPLATE.MANAGE.VERIFY.VAR.NOT.CREATE': 'Not created',
  'TEMPLATE.MANAGE.VERIFY.VAR.PLACEHOLDER.NAME.REG':
    'key "{name}" is incorrect. Only alphanumerical characters and underscores are supported.',
  'TEMPLATE.MANAGE.PREFERENCE.NONE': 'None',
  'TEMPLATE.MANAGE.PREFERENCE.UNSUBSCRIBE': 'Unsubscribe',
  'TEMPLATE.MANAGE.PREFERENCE.UNSUBSCRIBEANDSET': 'Preferences & Unsubscribe',
  'TEMPLATE.MANAGE.FOLDER.LABEL': 'Folder',
  'TEMPLATE.MANAGE.FOLDER.ADD': 'Add Folder',
  'TEMPLATE.MANAGE.FOLDER.EDIT': 'Edit Folders',
  'TEMPLATE.MANAGE.FOLDER.DONE': 'Done',
  'TEMPLATE.MANAGE.FOLDER.NAME.UNGROUPED': 'Unsorted',
  'TEMPLATE.MANAGE.FOLDER.NAME.UNGROUPED1': 'Unsorted',
  'TEMPLATE.MANAGE.FOLDER.NAME.BLANK.SPACE': 'Remove spaces (front and end)',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.TITLE': 'Create your first email template',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.DES':
    'After creating a template, it can be used in campaigns',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.TRANS.DES':
    '<p style="padding-bottom: 10px">Transactional emails are used to deliver key information, as opposed to promotional content.</p>' +
    'These are automated emails that are sent in response to an action a user takes on your website or in-game. Examples include purchase confirmations, password reset links or verification codes.',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.MAIL': 'Drag & drop',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.MAIL.MJML': 'Drag & Drop',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.HTML': 'Rich text editor',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.MJML': 'Upload an MJML file',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.UPLOAD': 'Import HTML',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.MARKDOWN': 'Rich text editor',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.DETAIL': 'Info',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.MAILTIP':
    'Drag and drop preset content blocks to create your template. Quickly build your template from <a href="{link}" target="_blank">scratch</a>.',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.MAILTIP.LINK':
    '/function-guide/manage-template-template-editor/',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.HTMLTIP':
    'File needs to be encoded in UTF-8 format',
  'TEMPLATE.MANAGE.ADD.TEMPLATE.MARKDOWNTIP':
    'Use the rich text editor for a simple way to create and edit personalized emails, without the need for complex typesetting.',
  'TEMPLATE.MANAGE.TEMPLATE.NAME.PLACEHOLDER': 'Enter template name',
  'TEMPLATE.MANAGE.TEMPLATE.GROUP': 'Folder name',
  'TEMPLATE.MANAGE.TEMPLATE.GROUP.NAME': 'Folder name',
  'TEMPLATE.MANAGE.TEMPLATE.GROUPPREFIX': 'Folder',
  'TEMPLATE.MANAGE.TEMPLATE.UPLOAD.TITLE': 'Choose a file or drag it here',
  'TEMPLATE.MANAGE.TEMPLATE.UPLOAD.DESC':
    'Refer to the <a href="{url}" style="color: #00a386;text-decoration: none;" target="_blank">HTML template guide</a> to create an email template that is compatible with SmartLink.',
  'TEMPLATE.MANAGE.TEMPLATE.UPLOAD.DESC.HTML.LABEL': 'HTML',
  'TEMPLATE.MANAGE.TEMPLATE.UPLOAD.DESC.HTML.CONTENT':
    'The HTML file needs to use UTF-8 or GBK.\nThe text content should not contain any garbled code.',
  'TEMPLATE.MANAGE.TEMPLATE.UPLOAD.DESC.MJML.LABEL': 'MJML',
  'TEMPLATE.MANAGE.TEMPLATE.UPLOAD.DESC.MJML.CONTENT':
    "MJML files are suitable for most popular email clients, like Outlook and Gmail.MJML files can be created manually in SmartLink's drag-and-drop email template editor, or through IDE tools or third-party platforms that support MJML.",
  'TEMPLATE.MANAGE.TEMPLATE.GROUPTIP':
    "Folders can help you organize sets of templates and they can be created on the 'Email templates' page.",
  'TEMPLATE.MANAGE.ADD.CONFIRM': 'Continue',
  'TEMPLATE.MANAGE.COPY.SUFFIX': 'copy',

  'TEMPLATE.MANAGE.MAIL.PLACEHOLDER.TITLE': 'Select a key',
  'TEMPLATE.MANAGE.MAIL.PLACEHOLDER.FIXED.TITLE': 'Fixed value key',
  'TEMPLATE.MANAGE.MAIL.PLACEHOLDER.FIXED.DYNAMIC': 'Dynamic value keys',
  'TEMPLATE.MANAGE.MAIL.PLACEHOLDER.SEARCH.PLACEHOLDER': 'Search',
  'TEMPLATE.MANAGE.MAIL.PLACEHOLDER.SEARCH.EMPTY': 'No data',
  'TEMPLATE.MANAGE.MAIL.PLACEHOLDER.ADD.BTN.TITLE': 'Add a new key',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.TITLE': 'Link',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.DISPALYTEXT': 'Display Text',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.LINKTYPE': 'Link Type',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.LINKTARGET': 'Open method',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.LINKTARGET.PLACEHOLDER': '<not set>',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.URL': 'URL',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.CUSTOM': 'Custom',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.UNSUBSCRIBE': 'Unsubscribe',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.UPDATEPRFERENCE': 'Update preferences',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.VIEW.EMAIL.BROWSER': 'View in browser',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.OPT.CONFIRM': 'Double opt-in confirmation',
  'TEMPLATE.MANAGE.MAIL.LINK.DIALOG.OK': 'OK',
  'TEMPLATE.MANAGE.MAIL.UNSUBSCRIBE': 'Unsubscribe',
  'TEMPLATE.MANAGE.MAIL.UPDATE.PREFERENCE': 'Update preferences',
  'TEMPLATE.MANAGE.MAIL.UPDATE.VIEW': 'View in browser',
  'TEMPLATE.MANAGE.MAIL.UPDATE.OPT': 'Confirms subscription',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.TITLE': 'Review placeholders and links',
  'TEMPLATE.MANAGE.MAIL.VERIFY.DIALOG.TITLE': 'Please confirm before saving',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.TITLE1':
    'Please confirm whether the key has been created or assigned a value',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.TITLE2':
    'Please confirm the link in the template & add a tag to the link',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.DETECTED': 'It is detected that',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.DETECTED2':
    'exist in the system. If you need to insert contact attributes or keys, please re - insert the correct contact attributes or keys in the template.',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.PLACEHOLDERS.TIP':
    'Review placeholders and links',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.LINKS.TIP':
    'Review the links and the text to display',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.LINKS.COLUMN.URL': 'URL',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.LINKS.COLUMN.TEXT': 'Display text',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.LINKS.COLUMN.IMG': 'Image',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.LINKS.COLUMN.NOTE': 'Label',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.LINKS.COLUMN.NOTETIP':
    'Notes can help you distinguish different links and they will be displayed in campaign reports.',
  'TEMPLATE.MANAGE.MAIL.REVIEW.DIALOG.FORMS.TIP': 'Check if forms are active',
  'TEMPLATE.MANAGE.MJML.DIALOG.IMPORT.ERROR': 'mjml format error',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.TITLE': 'Upload and select',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.SUBTITLE': 'Upload',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.LOADING.TEXT': 'loading...',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.SUBTITLE.LIMIT.TYPE': 'please upload image',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.SUBTITLE.LIMIT.SUPER':
    'Internal accounts cannot upload',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.SUBTITLE.LIMIT.SIZE': 'limit 5MB',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.DEL.TIP': 'Delete image?',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.DEL.CANCEL': 'Cancel',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.DEL.CONFIRM': 'Confirm',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.BEEN.DELETE': 'Picture has been deleted',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.COMPONENT.TIP':
    '<span style="font-weight: bold">Drop files here or <span  class="color-primary">click to upload</span></span>',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.COMPONENT.TIP2':
    '<span style="color: #666666;font-size: 14px;">Supports <span  class="color-primary">.jpg, .jpeg, .png, .gif, .bmp, .tif, .tiff</span></span>',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.COMPONENT.TIP2.1':
    '<span style="color: #666666;font-size: 14px;">Supports <span  class="color-primary">.jpg, .jpeg, .png</span></span>',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.COMPONENT.TIP3':
    '<span style="color: #666666;font-size: 14px;">File size limit <span  class="color-primary">5MB</span></span>',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.SUBTITLE.IMAGE.URL': 'Image url',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.SUBTITLE.IMAGE.URL.PLACEHOLDER':
    'http://path/to/the/image',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.RIGHT.TIP': 'Select image',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.ASSETS.EMPTY.TIP':
    'There are currently no images available.<br>please upload or add them',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.ASSETS.CONFIRM.EMPTY': 'please select image',
  'TEMPLATE.MANAGE.MAIL.UPLOAD.INPUT.URL.FAIL': 'Invalid image link',
  'TEMPLATE.MANAGE.MJML.CONTENT': 'Content',
  'TEMPLATE.MANAGE.MJML.IMG.SOURCE.ERROR':
    'Dragging pictures from outside the editor is not supported',
  'TEMPLATE.MANAGE.MJML.ROW': 'Row',
  'TEMPLATE.MANAGE.MJML.BODY': 'Body',
  'TEMPLATE.MANAGE.MJML.URL.RESELECT.TIP':
    'Text recognition failed. Please try again.',
  'TEMPLATE.MANAGE.MJML.URL.RESELECT.LI.TEXT':
    'Limit list text from adding links across lines',
  'TEMPLATE.MANAGE.MJML.SET': 'Settings',
  'TEMPLATE.MANAGE.MJML.PREVIEW': 'Exit preview',
  'TEMPLATE.MANAGE.MJML.LOAD': 'loading',
  'TEMPLATE.MANAGE.EDITOR.SAVE.TIP': 'Save',
  'TEMPLATE.MANAGE.EDITOR.SAVE.TRANS.PUBLIC.TIP': 'Save',
  'TEMPLATE.MANAGE.EDITOR.SAVE.DISABLED.SAVED.BTN':
    'No changes to subject and preview text. Saving is not required.',
  'TEMPLATE.MANAGE.EDITOR.SAVE.SAVED.SUCCESS': 'Subject and preview text saved',
  'TEMPLATE.MANAGE.EDITOR.SAVE.SAVED.DIALOG.HEADER.TITLE':
    'Save subject and preview text?',
  'TEMPLATE.MANAGE.EDITOR.SAVE.SAVED.DIALOG.SAVED': 'Save',
  'TEMPLATE.MANAGE.EDITOR.SAVE.SAVED.DIALOG.DONT.SAVED': "Don't save",
  'TEMPLATE.MANAGE.EDITOR.SAVE.TRANS.TIP': 'Save draft',
  'TEMPLATE.MANAGE.EDITOR.PUBLISH.TIP': 'Publish',
  'TEMPLATE.MANAGE.EDITOR.EDIT.LOADING':
    ' <span class="editing">Editing</span>',
  'TEMPLATE.MANAGE.EDITOR.SAVE.LOADING': ' <span class="saving">Saving</span>',
  'TEMPLATE.MANAGE.EDITOR.SAVE.LOADING.PROCESS': 'Automatically saving',
  'TEMPLATE.MANAGE.EDITOR.SAVE.FINISH': '<span class="saved">Saved</span>',
  'TEMPLATE.MANAGE.EDITOR.SAVE.ERROR': '<span class="saved">Save failed</span>',
  'TEMPLATE.MANAGE.MJML.EDIT.SAVE.TIP':
    '<span class="tip-title">Save changes reminder</span><br/>' +
    '<span class="tip-content">No changes detected for more than 30 minutes. Other users can start editing after another 10 minutes of inactivity.</span>',
  'TEMPLATE.MANAGE.MJML.EDIT.TIMEOUT.AND.BEING.EDITED.TIP':
    '<span class="tip-title">Save changes reminder</span><br/>' +
    '<span class="tip-content">More than 40 minutes of inactivity, the template has been edited by another user.</span>',
  'TEMPLATE.MANAGE.MJML.EDIT.TIMEOUT.TIP':
    '<span class="tip-title">Save changes reminder</span><br/>' +
    '<span class="tip-content">More than 40 minutes of inactivity</span>',
  'TEMPLATE.MANAGE.LIST.TIMEOUT.TIP':
    '<span style="text-indent: 28px;display: inline-block">No changes detected for more than 40 minutes. Template "{timeoutTemplateName}" can be edited by other users.</span>',
  'TEMPLATE.MANAGE.MJML.EDIT.NETWORK.TIP':
    '<span class="tip-title">Network failed</span><br/>' +
    '<span class="tip-content">Network connection was lost and the template content is not saved. \n' +
    'Others can now edit this template.</span>',
  'TEMPLATE.MANAGE.content.XSS.TIP':
    'Save failed. Please try deleting <span style="color:red">{msg}</span> and save again.',

  'TEMPLATE.MANAGE.LOCK.TIP': 'This template has been edited by other users.',
  'TEMPLATE.MANAGE.NO.PERMISSION.TIP': 'no permission',
  'TEMPLATE.MANAGE.NO.ID': 'Invalid template id',
  'TEMPLATE.MANAGE.NO.PUB.PARAMS': 'Please fill in subject and sender',
  'TEMPLATE.MANAGE.TEMPLATE.RETURN.TIP': 'Save changes',
  'TEMPLATE.MANAGE.TEMPLATE.RETURN.BODY.TIP':
    'Save changes made to this template.',
  'TEMPLATE.MANAGE.TEMPLATE.RETURN.CANCEL': "Don't save",
  'TEMPLATE.MANAGE.TEMPLATE.RETURN.CONFIRM': 'Save',

  'TEMPLATE.MANAGE.TEMPLATE.PUBLISH.TIP': 'Publish transactional email',
  'TEMPLATE.MANAGE.TEMPLATE.PUBLISH.CONTENT':
    'After this transactional email is published, interfaces using this email will immediately show the new content. lt is recommended to send a test email before publishing a template.',
  'TEMPLATE.MANAGE.TEMPLATE.PUBLISH.BOTTOM':
    'Are you sure you want to publish this template?',

  // html monaco editor
  'TEMPLATE.MANAGE.HTML.EDITOR.CODE.TAB.TIP': 'Edit HTML code',
  'TEMPLATE.MANAGE.HTML.EDITOR.ADD.SUBJECT.PREVIEW': 'Subject',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.TAB.TIP': 'Edit functional links',
  'TEMPLATE.MANAGE.HTML.EDITOR.SET.TAB.TIP': 'Settings',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.TAB.TIP.CONTENT.TITLE':
    "Insert links ('View email in browser' currently only supports custom styles)",
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.SELECT.TITLE': 'Insert standard style',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.SELECT.LABEL': 'Component',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.CUSTOM.TITLE': 'Insert custom style',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.CUSTOM.SUBTITLE':
    'If you want to customize the display of the link, you can copy the code block into "Edit code"',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.CUSTOM.UNSUB.TIP': '1、 Unsubscribe',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.CUSTOM.UPDATE.TIP':
    '2、 Update preferences',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.CUSTOM.VIEW.TIP':
    '3、 View this email in your browser',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.CUSTOM.OPT.CONFIRM.TIP':
    '4、 Confirms subscription',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.COPY.TIP': 'Copy',
  'TEMPLATE.MANAGE.HTML.EDITOR.SAVE.PREVIEW.TAB.TIP': 'Save code & preview',
  'TEMPLATE.MANAGE.HTML.EDITOR.SAVE.LINK.TAB.TIP': 'Confirm',
  'TEMPLATE.MANAGE.HTML.EDITOR.COPY.SUCCESS': 'copy success',
  'TEMPLATE.MANAGE.HTML.EDITOR.LINK.SELECT.SAVE':
    "Select a template language and you can preview the standard 'Unsubscribe & update preferences' link.",

  // rich
  'TEMPLATE.MANAGE.RICH.PLACEHOLDER.TIP': 'keys',
  'TEMPLATE.MANAGE.RICH.IMG.TIP': 'image',
  'TEMPLATE.MANAGE.RICH.LINK.TIP': 'link',

  'TEMPLATE.MANAGE.TEMPLATE.UPDATE': 'Update by',

  //   add font
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.TITLE': 'Add web fonts',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT':
    '<span style="font-weight: 700">Google fonts may not supported by all email clients. When they\'re not supported by the email client, </span> your recipients will see the fallback font.',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT.MORE': 'Learn more',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT.TAB.GOOGLE': 'Free fonts',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT.TAB.CUSTOM': 'Custom fonts',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT.SEARCH.PHD':
    'Search Google font',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT.SEARCH.WEB.PHD':
    'Search custom font',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT.FALLBACK.TITLE':
    'Fallback font',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT.FALLBACK.DES':
    'If the web font is not supported by an email client, the fallback font will be used.',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONTENT.DEFAULT.SELECT.DES':
    'Subject, body, buttons, other text',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CANCEL': 'Cancel',
  'TEMPLATE.MANAGE.MAIL.FONT.ADD.DIALOG.CONFIRM': 'Add selected font',

  //   send-email
  'TEMPLATE.MANAGE.MAIL.TEST.EMAIL.INPUT.DES':
    'When adding multiple recipients, you can separate each address by pressing Tab or Enter or with any of these keys: , | \\',
  'TEMPLATE.MANAGE.TRANS.MAIL.TEST.EMAIL.INPUT.DES': 'Recipient(s)',
  'TEMPLATE.MANAGE.TRANS.MAIL.TEST.EMAIL.INPUT.PHD': 'Enter email address',
  'TEMPLATE.MANAGE.MAIL.TEST.EMAIL.VAR.PHD': 'var{index}',
  'TEMPLATE.SUBJECT.MAX.LENGTH.ERROR': 'Cannot exceed {length} characters',
  'TEMPLATE.SEND.VAR.REPLACE.WITH':
    'Variable <span style="color:#00a386;font-weight: bold;">{name}</span> replace width',
  'TEMPLATE.SEND.EMAIL.TIP':
    "Complete the email configurations under 'Settings'",
  'TEMPLATE.PANEL.SAVE.SUCCESS':
    'Subject & Sender infomation saved successfully',
  'TEMPLATE.PANEL.SAVE.PANEL.SUCCESS': 'Saved successfully',
  'TEMPLATE.SEND.EMAIL.DES':
    'When adding multiple recipients, you can separate each address by pressing Tab or Enter or with any of these keys: , | \\',
  'TEMPLATE.SEND.EMAIL.DOMAIN.EMPTY':
    'No domain added yet, please contact the SmartLink team (<a href="mailto:SmartLink_service@proximabeta.com" style="text-underline: none;">SmartLink_service@proximabeta.com</a>)',
  'TEMPLATE.SEND.EMAIL.DOMAIN.TIP':
    'No domain added yet, please contact the SmartLink team',
  'TEMPLATE.DOMAIN.PENDING.TIP': 'Not yet configured',

  //   list 类型
  // 'TEMPLATE.MANAGE.LIST.MARKET': 'Marketing',
  // 'TEMPLATE.MANAGE.LIST.TRANSACTION': 'Transactional',
  'TEMPLATE.MANAGE.LIST.TIME.TIP': 'Revocation details',
  'TEMPLATE.MANAGE.LIST.TIME.PUB.INFO': 'Published on {time} by {user}',
  'TEMPLATE.MANAGE.LIST.TIME.PUB.INFO.HTML':
    'Published on<br/> {time}<br/> <span style="color:#666666">---by {user}</span>',
  'TEMPLATE.MANAGE.LIST.TIME.UPDATE.INFO': 'Revoked on {time} by {user}',
  'TEMPLATE.MANAGE.LIST.TRANS.SEND.DRAFT': 'Send test email (Draft)',
  'TEMPLATE.MANAGE.LIST.TRANS.SEND.PUBLISHED': 'Send test email (Published)',
  'TEMPLATE.MANAGE.LIST.TRANS.PUBLISHED': 'Revoke publication',

  'TEMPLATE.MANAGE.TRANSACTION.PUBLIC.IMG': 'Published',
  'TEMPLATE.MANAGE.TRANSACTION.DRAFT.IMG': 'Draft',
  'TEMPLATE.MANAGE.TRANSACTION.NO.PUB.IMG.TIP': 'NOT\n' + 'PUBLISHED',
  'TEMPLATE.MANAGE.TRANSACTION.NO.DRAFT.IMG.TIP': 'NOT\n' + 'SAVED',
  'TEMPLATE.MANAGE.TRANSACTION..DRAFT.IMG.SAME': 'same as\n' + 'published',
  'TEMPLATE.MANAGE.TRANSACTION.ID': 'ID',
  'TEMPLATE.MANAGE.TRANSACTION.NAME': 'Name',
  'TEMPLATE.MANAGE.TRANSACTION.LANG': 'Language',
  'TEMPLATE.MANAGE.TRANSACTION.PHD': 'keys/Contact attributes',
  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.TIME': 'Last published',
  'TEMPLATE.MANAGE.TRANSACTION.CONTENT.VERIFY': 'Email content cannot be empty',

  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.SET.TITLE': 'Sender & subject',
  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.SET.SENDER': 'Sender',
  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.SET.SENDER.NAME': 'Select sender name',
  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.SET.SENDER.ADDRESS': 'Sender address',
  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.SET.SENDER.ADDRESS.TIP':
    'Select sender address',
  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.SET.SENDER.SUBJECT': 'Subject',
  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.SET.SENDER.SUBJECT.PHD':
    'Enter subject line',
  'TEMPLATE.MANAGE.TRANSACTION.PUBLISH.SET.SENDER.PREVIEW.PHD':
    'Appears in the inbox after the subject line',

  //   CLOSE
  'TEMPLATE.MANAGE.CLOSE.TEXT': 'Close',
  'TEMPLATE.LINK.DIALOG.PLEASE.ENTER': 'Enter text to display',

  //   mjml
  'TEMPLATE.MJML.CONTENT.TAB.BLOCKS': 'Content block',
  'TEMPLATE.MJML.CONTENT.TAB.SECTIONS': 'Section',
  'TEMPLATE.MJML.CONTENT.TAB.SECTIONS.TIP': 'Text & Images',
  'TEMPLATE.MJML.CONTENT.COLOR.PICKER.HEX.TIP': 'Hex',
  'TEMPLATE.MJML.CONTENT.COLOR.PICKER.CANCEL.TIP': 'Cancel',
  'TEMPLATE.MJML.CONTENT.COLOR.PICKER.CONFIRM.TIP': 'Confirm',
  'TEMPLATE.MJML.CONTENT.COLOR.PICKER.GRAD.VAL': 'Gradient',
  'TEMPLATE.MJML.CONTENT.COLOR.PICKER.SOLID.VAL': 'Solid',
  'TEMPLATE.MJML.CONTENT.COLOR.PICKER.GRAD.HISTORY': 'Recent colors',
  'TEMPLATE.MJML.CONTENT.COLOR.PICKER.GRAD.SYSTEM': 'Standard colors',

  // html 提示
  'TEMPLATE.MANAGE.TEMPLATE.UPLOAD.HTML.DETECT': 'Promotion Predictor',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.TITLE': 'Promotion Predictor',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.SUBTITLE':
    'The followings may increase the risk of emails being categorized as Gmail promotions.',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.TAG': 'Tags',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.TAG.TIP': 'Looks good',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.TAG.WARN.TIP':
    'Recommend: lower it down below 116',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.TEXT.RADIO': 'Text to html ratio',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.TEXT.RADIO.TIP': 'Looks good',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.TEXT.RADIO.WARN.TIP':
    'Recommend: increase it higher than 7.63%',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.CODE': 'Length of code',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.CODE.TIP': 'Looks good',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.CODE.WARN.TIP':
    'Recommend: lower it down below 28685',
  'TEMPLATE.MANAGE.TEMPLATE.HTML.DETECT.CANCEL.TIP': 'Cancel',

  // 创建 模板
  'TEMPLATE.CREATE.BASIC': 'Standard templates',
  'TEMPLATE.CREATE.BASIC.01': 'Standard template 01',
  'TEMPLATE.CREATE.BASIC.02': 'Standard template 02',
  'TEMPLATE.CREATE.BASIC.03': 'Standard template 03',
  'TEMPLATE.CREATE.HISTORY': 'My templates',
  'TEMPLATE.CREATE.HTML': 'Import template',
  'TEMPLATE.CREATE.BASIC.TITLE': 'Standard templates',
  'TEMPLATE.CREATE.BASIC.CONTENT.APPLY': 'Select',
  'TEMPLATE.CREATE.BASIC.CONTENT.EMPTY': 'No templates',
  'TEMPLATE.CREATE.LANG.PHD': 'All',
  'TEMPLATE.CREATE.LANG.PREFIX.PHD': 'Language',
  'TEMPLATE.CREATE.FOLDER.PHD': 'All',
  'TEMPLATE.CREATE.BASIC.CONTENT.DES': 'Start from scratch',
  'TEMPLATE.CREATE.BASIC.LAYOUT.BLANK': 'Start from scratch',
  'TEMPLATE.CREATE.BASIC.LAYOUT.1_2_COLUMN': '1-2 Column',
  'TEMPLATE.CREATE.BASIC.LAYOUT.1_2_1_COLUMN': '1-2-1 Column',
  'TEMPLATE.CREATE.BASIC.LAYOUT.1_3_COLUMN': '1-3 Column',
  'TEMPLATE.CREATE.BASIC.LAYOUT.1_3_2_COLUMN': '1-3-2 Column',
  'TEMPLATE.CREATE.BASIC.LAYOUT.ALTERNATE': 'Alternate',

  'TEMPLATE.CREATE.HTML.TIP.1':
    'Import HTML File needs to be encoded in UTF-8 format.',
  'TEMPLATE.CREATE.HTML.TIP.2':
    'To make sure the file is compatible, refer to the <a href="{url}" style="color: #00a386;text-decoration: none;" target="_blank">HTML template creation guide</a> when creating your email template.',
  'TEMPLATE.CREATE.HTML.DES': 'Import HTML',
  'TEMPLATE.CREATE.HTML.TIP.3':
    'Contact attributes or keys can be inserted into the template. The contact attributes that can be inserted are:',

  'TEMPLATE.CREATE.HTML.TIP.4':
    '(1) When inserting an attribute as personal information into the email template or subject, the attribute name can only consist of English letters, numbers, and underscores.',

  'TEMPLATE.CREATE.HTML.TIP.5':
    '(2) There is a one - to - one relationship between the contact attribute name and the attribute value. Attributes of preference or option types are not supported for insertion. Any other contact attributes whose naming meets the requirements can be inserted.',

  'TEMPLATE.CREATE.MJML.TIP.1':
    'Import MJML File needs to be encoded in UTF-8 format.',
  'TEMPLATE.CREATE.MJML.TIP.2':
    'To make sure the file is compatible, refer to the <a href="{url}" style="color: #00a386;text-decoration: none;" target="_blank">MJML template creation guide</a> when creating your email template.',
  'TEMPLATE.CREATE.MJML.DES': 'Import MJML',

  // 接入指引 - 营销型邮件模板
  'TEMPLATE.MARKETING.DRAWER.TITLE': 'Marketing Email Template Guide',
  'TEMPLATE.MARKETING.DRAWER.CONTENT.TITLE.1': 'Template Creation',
  'TEMPLATE.MARKETING.DRAWER.CONTENT.DESCRIPTION.1':
    '<li>To create a template, use a standard template, a template you have created before or directly import an HTML template.</li><li>A template can only be edited by one user at a time.</li><li>Add a link to the template to allow recipients to easily unsubscribe, update preferences, or view the email in a browser.</li>',
  'TEMPLATE.MARKETING.DRAWER.CONTENT.TITLE.2': 'Template Use',
  'TEMPLATE.MARKETING.DRAWER.CONTENT.DESCRIPTION.2':
    '<li>Regular campaigns, recurring campaigns and A/B tests can directly use marketing email templates.</li><li>Player journey can directly use a marketing email as the send email.</li>',

  'TEMPLATE.TRANS.DRAWER.TITLE': 'Transactional Email Template Guide',
  'TEMPLATE.TRANS.DRAWER.LABEL.1':
    'Use the <a href="{url}" style="color: #00a386;text-decoration: none;" target="_blank">delivery API</a> in SmartLink (link to API interface page) to send transactional emails to contacts. These emails can be triggered by actions on a website or in-game.',
  'TEMPLATE.TRANS.DRAWER.LABEL.2': 'Setup Procedure',
  'TEMPLATE.TRANS.DRAWER.CONTENT.TITLE.1': 'Step 1. Configure sender domain',
  'TEMPLATE.TRANS.DRAWER.CONTENT.DESCRIPTION.1':
    'To ensure the separation of Transactional Emails and Marketing Emails, please contact the SmartLink operations team (or email <a href="mailto:SmartLink_service@proximabeta.com style="color: #00a386;text-decoration: none;" target="_blank"">SmartLink_service@proximabeta.com</a>) to configure the sending domain.',
  'TEMPLATE.TRANS.DRAWER.CONTENT.TITLE.2': 'Step 2: Edit Email Content',
  'TEMPLATE.TRANS.DRAWER.CONTENT.DESCRIPTION.2':
    'Create and test your email templates on this page. For details, refer to <a href="{url}" style="color: #00a386;text-decoration: none;" target="_blank">Create Transactional Email Content | SmartLink</a>.',
  'TEMPLATE.TRANS.DRAWER.CONTENT.TITLE.3': 'Step 3: Test Email Sending',
  'TEMPLATE.TRANS.DRAWER.CONTENT.DESCRIPTION.3':
    'Obtain a dedicated API Key by contacting the SmartLink operations team or emailing <a href="mailto:SmartLink_service@proximabeta.com style="color: #00a386;text-decoration: none;" target="_blank"">SmartLink_service@proximabeta.com</a>. Note: The API Key in SmartLink > Settings is not applicable for Transactional Emails. For detailed debugging steps, refer to the <a href="{url}" style="color: #00a386;text-decoration: none;" target="_blank">Developer Documentation: Send Transactional Emails | SmartLink</a>',
  'TEMPLATE.TRANS.DRAWER.CONTENT.TITLE.4':
    'Step 4: Check Email Delivery Status',
  'TEMPLATE.TRANS.DRAWER.CONTENT.DESCRIPTION.4':
    'SmartLink allows you to query the delivery status of each Transactional Email request. For more information, see <a href="{url}" style="color: #00a386;text-decoration: none;" target="_blank">Query Sent Email Status | SmartLink</a>',
  'TEMPLATE.TRANS.DRAWER.REMINDER.TITLE': 'Note',
  'TEMPLATE.TRANS.DRAWER.REMINDER.1':
    'The email domain used for transactional emails needs to be different from the email domain for marketing emails. This is done in order to isolate the domain reputation.',
  'TEMPLATE.TRANS.DRAWER.REMINDER.2':
    'By default the daily limit for sending transactional emails is 1.5 million for each project, with a QPS (Queries Per Second) of 200. To increase this daily limit, reach out to your SmartLink point of contact 3 working days in advance or send an email to <a href="mailto:SmartLink_service@proximabeta.com style="color: #00a386;text-decoration: none;" target="_blank"">SmartLink_service@proximabeta.com</a>',
  // 营销模板
  'TEMPLATE.MARKETING.BASELINE.LANG.NOTIFICATION':
    'Select the language for this template',
  'TEMPLATE.MARKETING.LANG.LABEL': 'Enable multiple languages',
  'TEMPLATE.MARKETING.LANG.TITLE': 'Select other language',
  'TEMPLATE.MARKETING.LANG.PLACEHOLDER': 'Select language',
  'TEMPLATE.MARKETING.LANG.SEARCH': 'Search language',
  'TEMPLATE.MARKETING.FILE.EXPORT.TITLE': 'Export text',
  'TEMPLATE.MARKETING.FILE.EXPORT': 'Download multilingual template',
  'TEMPLATE.MARKETING.FILE.EXPORT.TOTAST': 'Select your languages',
  'TEMPLATE.MARKETING.FILE.EXPORT.TIPS':
    "Note: Only content from 'text' and 'buttons' will be exported",
  'TEMPLATE.MARKETING.FILE.UPLOAD.TITLE': 'Upload multilingual template',
  'TEMPLATE.MARKETING.FILE.UPLOAD.GUIDE': 'Select CSV file or drag it here',
  'TEMPLATE.MARKETING.FILE.UPLOAD.TIPS.1':
    '1. Only supports CSV files encoded in UTF-8 format',
  'TEMPLATE.MARKETING.FILE.UPLOAD.TIPS.2':
    '2. Maximum upload file size: {size}MB',
  'TEMPLATE.MARKETING.FILE.UPLOAD.TIPS.3':
    '3. Keys need to be consistent in all languages',
  'TEMPLATE.MARKETING.FILE.UPLOAD.TIPS.4':
    '4. Text in other languages will follow the text format of the first character in the original text',
  'TEMPLATE.MARKETING.UPLOAD.FILED.TITLE': 'Upload error',
  'TEMPLATE.MARKETING.FILE.ERROR.OVER.MAX.SIZE':
    'Only the CSV format is supported, up to {num}MB per file.',
  'TEMPLATE.MARKETING.FILE.ERROR.TIME.OUT': 'File upload timeout',
  'TEMPLATE.MARKETING.FILE.ERROR.TYPE': 'File format not supported',
  'TEMPLATE.MARKETING.FILE.ERROR.HEADER.LANG.ERROR': 'Language mismatch',
  'TEMPLATE.MARKETING.FILE.ERROR.LINE.HEADER.ERROR': 'Column header mismatch',
  'TEMPLATE.MARKETING.FILE.ERROR.PLACEHOLDER.ERROR':
    'Data error - key does not match',
  'TEMPLATE.MARKETING.ERROR.PLACEHOLDER.ERROR': 'key does not match',
  'TEMPLATE.MARKETING.FILE.UPLOAD.SUCCESS.STATISTICAL':
    '<span class="color-666">Uploaded <b class="font-size-16 color-333">{rowNum} text components</b> in <b class="font-size-16 color-333">{langNum} languages.</b></span>',
  'TEMPLATE.MARKETING.SETTING.SAVE': 'Settings saved successfully',

  //   保存提示form
  'TEMPLATE.MARKETING.SETTING.FORM.SAVE': 'Select form in component settings',
  //   测试邮件
  'TEMPLATE.MARKETING.TEST.EMAIL.FORM.TIP1':
    "Data submitted through forms in this test email are only synchronized to SmartLink if the form is 'Active' and the recipient is an existing contact.",
  'TEMPLATE.MARKETING.TEST.EMAIL.FORM.TIP2': '',
  'TEMPLATE.MARKETING.TEST.EMAIL.FORM.TIP3': '',
  'TEMPLATE.MARKETING.TEST.EMAIL.CONFIRM.TXT': 'Send without Updating',
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.HEADER': 'Subject Updated',
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.DES':
    'Would you like to sync these changes to your template before sending?',
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.BASELINE':
    'Template Subject & Preview Text',
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.CONTRAST':
    'Test Email Subject & Preview Text',
  'TEMPLATE.MARKETING.TEST.EMAIL.CONFIRM.UPDATE.TXT': 'Confirm Update',

  //   subject 检测提示
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.DETECT.SENSITIVE.PREFIX':
    'The word{suffix} ',
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.DETECT.SENSITIVE.WORD': '{content}',
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.DETECT.SENSITIVE.WORD.TIP1':
    'Gmail, Outlook and other email providers typically review subject lines and may classify emails with promotional content as "Promotions" or "Junk." To help you improve deliverability, we offer targeted spam word detection. Want to learn more?',
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.DETECT.SENSITIVE.WORD.TIP2':
    ' Click to view the full guide.',
  'TEMPLATE.MARKETING.TEST.EMAIL.SUBJECT.DETECT.SENSITIVE.SUFFIX':
    ' may trigger spam filters and reduce deliverability. Consider using alternative wording.',
  'TEMPLATE.ADD.VARIABLE.DIALOG.HEADER': 'Select contact attribute.',
  'TEMPLATE.ADD.VARIABLE.DIALOG.CONTACT.LABEL':
    'Which contact attribute do you want to insert',
  'TEMPLATE.ADD.VARIABLE.DIALOG.CONTACT.LABEL.DES':
    'After the email is sent, the contact information within the system will be used for replacement.',
  'TEMPLATE.ADD.VARIABLE.DIALOG.CONTACT.TOOLTIP':
    'If you need to insert, the attribute name can only be composed of English letters, numbers, and underscores. Please go to the attribute settings to modify the attribute name first.',
  'TEMPLATE.ADD.VARIABLE.DIALOG.DEFAULT.VALUE.LABEL':
    'If the attribute is empty, which value should be used?',
  'TEMPLATE.ADD.VARIABLE.DIALOG.OPTION.TOOLTIP':
    'The attribute is inserted into the email template or subject as personal information. The attribute name can only consist of English letters, numbers, and underscores. If insertion is required, the name needs to be modified.',
  'TEMPLATE.ADD.VARIABLE.DIALOG.CONTACT.ERROR':
    '<span title="">The attribute is inserted into the email template or subject as personal information. The attribute name can only consist of English letters, numbers, and underscores. If insertion is required, the name needs to be <a href="{href}" target="_blank">modified</a>.</span>',
  'TEMPLATE.ADD.VARIABLE.DIALOG.CONTACT.WHATSAPP.ERROR':
    '<span title="">The attribute is inserted as personal information. The attribute name can only consist of English letters, numbers, and underscores. If insertion is required, the name needs to be <a href="{href}" target="_blank">modified</a>.</span>',
  'TEMPLATE.ADD.VARIABLE.DIALOG.DEFAULT.VALUE.ERROR':
    'Default value cannot be empty',
  'TEMPLATE.MANAGE.ADD.Subject.PREVIEW.TEXT': 'Subject',
  'TEMPLATE.MANAGE.ADD.Subject.PREVIEW.TEXT.TOOLTIP':
    'Set template subject and preview text here',

  // 多语言模板对比弹窗文案
  'TEMPLATE.MAIL.COMPARE.TITLE':
    'Reminder: Please confirm if you have modified the campaign subject',
  'TEMPLATE.MAIL.COMPARE.BASELINE.TITLE': 'Template subject',
  'TEMPLATE.MAIL.COMPARE.CONTRAST.TITLE': 'Campaign Subject',
};
